import React, { createContext, useContext } from 'react';
import type { ViewMode } from './ViewerToolbar';

export interface ViewerContainerValue {
  width: number;
  height: number;
  initialViewMode?: ViewMode;
  toolbarExtra?: React.ReactNode;
  dimensionCache?: Map<string, { width: number; height: number }>;
}

const defaultValue: ViewerContainerValue = { width: 800, height: 600 };

export const ViewerContainerContext = createContext<ViewerContainerValue>(defaultValue);

export function useViewerContainer(): ViewerContainerValue {
  return useContext(ViewerContainerContext);
}
